module.exports = __webpack_public_path__ + "static/media/doge.fed41358.png";